import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Address, RequestService } from 'clicklease-ui-elements';
import { environment } from '@envs/environment';
import { PaymentPlan, PromiseToPay, StatementData, StatementDates, UpdateSuccess } from './../../interfaces';
import { DownloadLeaseAgreementData } from '../../interfaces/download-lease-agreement';

@Injectable({
    providedIn: 'root',
})
export class LeaseService extends RequestService {
    protected readonly serviceBaseUrl: string = `${environment.API_URL}leases/`;

    public getPaymentList(leaseKey: string): Observable<PaymentPlan> {
        return this.get<PaymentPlan>({
            url: `${leaseKey}/payments`,
            headers: {
                'content-type': 'application/json',
            },
        });
    }

    public getPromisesToPay(leaseKey: string): Observable<PromiseToPay[]> {
        return this.get<PromiseToPay[]>({
            url: `${leaseKey}/promisesToPay`,
            headers: {
                'content-type': 'application/json',
            },
        });
    }

    public updateEquipmentAddress(
        leaseKey: string,
        params: Address
    ): Observable<UpdateSuccess> {
        return this.put<UpdateSuccess>({
            url: `${leaseKey}/equipmentAddress`,
            params,
            headers: {
                'content-type': 'application/json',
            },
        });
    }

    public postDownloadLeaseStatement(
        leaseKey: string,
        params: StatementDates
    ): Observable<StatementData> {
        return this.post<StatementData>({
            url: `${leaseKey}/statement`,
            params,
            headers: {
                'content-type': 'application/json',
            },
        });
    }

    public getAgreement(leaseKey: string): Observable<DownloadLeaseAgreementData> {
        return this.get<DownloadLeaseAgreementData>({
            url: `${leaseKey}/agreement`,
            headers: {
                'content-type': 'application/json',
            },
        });
    }
}
